import { useUnmount as J } from "@decentriq/hooks";
import { testIds as K } from "@decentriq/utils";
import { useState as v, useCallback as c } from "react";
import L from "./useFileToBase64.js";
import { getImageFromFile as Q, validateImage as k, getImageDimensions as V, getImageFromBase64Data as X, getCroppedImg as Y } from "./utils.js";
const h = {
  aspectRatio: 1,
  canvasSize: {
    height: 500,
    width: 500
  },
  fillMode: "transparent",
  maxSizeInMbs: 25,
  minImageDimensions: {
    height: 100,
    width: 100
  }
}, ae = ({
  onError: n,
  onCroppingComplete: C,
  onImageSelectionComplete: D,
  options: E = h,
  testIdPrefix: x = ""
}) => {
  const {
    aspectRatio: f = h.aspectRatio,
    fillMode: u,
    maxSizeInMbs: S = h.maxSizeInMbs,
    minImageDimensions: {
      height: l,
      width: d
    } = h.minImageDimensions,
    canvasSize: s = h.canvasSize
  } = E, y = L(), [g, z] = v(null), [F, M] = v(null), P = v(null)[1], o = c((t) => P((i) => (i && document.body.removeChild(i), t && document.body.appendChild(t), t)), [P]);
  J(() => {
    o(null);
  });
  const H = c(() => new Promise((t, i) => {
    const a = document.createElement("input");
    a.setAttribute("data-testid", x + K.components.imageCropper.fileInput), a.hidden = !0, a.type = "file", a.accept = "image/png, image/jpeg, image/gif", a.multiple = !1, a.onchange = (I) => {
      const b = I.target;
      if (!b.validity.valid) {
        const e = new Error("Invalid image format");
        n?.(e), i(e);
        return;
      }
      if (!b.files?.length) {
        const e = new Error("No file provided");
        n?.(e), i(e);
        return;
      }
      o(null);
      const $ = b.files[0];
      Q($).then(async (e) => {
        const {
          image: m,
          dimensions: R,
          size: N
        } = e;
        k({
          dimensions: R,
          maxSizeInMbs: S,
          minDimensions: {
            height: l,
            width: d
          },
          size: N
        });
        const B = u === "none" ? R : V(m, f), p = Math.max(B.width, s.width), w = Math.max(B.height, s.height), A = new OffscreenCanvas(p, w), r = A.getContext("2d");
        if (!r)
          throw Error("Context is missing");
        const _ = (p - m.width) / 2, q = (w - m.height) / 2;
        u === "white" && (r.beginPath(), r.fillStyle = "white", r.rect(0, 0, p, w), r.fill()), r.drawImage(m, _, q);
        const G = await A.convertToBlob(), T = await y(new File([G], "image.png"));
        if (!T)
          throw new Error("Failed to load image");
        return {
          base64Data: T,
          height: w,
          width: p
        };
      }).then(async (e) => {
        const {
          image: m
        } = await X(e.base64Data);
        return {
          ...e,
          image: m
        };
      }).then((e) => {
        z(e), D?.(e), t(e);
      }).catch((e) => {
        n?.(e), i(e);
      });
    }, o(a), a.click();
  }), [y, z, D, n, f, u, S, o, x, l, d, s.width, s.height]), O = c(() => {
    try {
      if (!g)
        throw new Error("Please select image before cropping");
      const t = Y(g.image, F, 0);
      if (!t)
        throw new Error("Unable to crop image");
      const {
        base64Data: i,
        width: a,
        height: I
      } = t;
      return k({
        dimensions: {
          height: I,
          width: a
        },
        minDimensions: {
          height: l,
          width: d
        }
      }), C?.(i, `data:image;base64,${i}`), i;
    } catch (t) {
      throw n?.(t), t;
    }
  }, [g, F, n, l, d, C]), U = c((t, i) => M(i), [M]), W = c(() => o(null), [o]);
  return {
    ImageCropperProps: {
      aspectRatio: f,
      height: s.height,
      imageSrc: g ? `data:image;base64,${g.base64Data}` : null,
      onCropComplete: U,
      width: s.width
    },
    cropImage: O,
    resetImageSelection: W,
    selectImage: H
  };
};
export {
  ae as useImageCropper
};
//# sourceMappingURL=useImageCropper.js.map
